// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"336a40cd","19":"953dbc0b","268":"94819850","415":"df990bfa","475":"5075bf71","673":"a940af55","678":"29ab33df"}[chunkId] + ".chunk.js";
};